const e={virtualPaymentAddress:{validate:e=>!!e&&e.length>0,errorMessage:"",modes:["blur"]},default:{validate:e=>!!e&&e.length>0,errorMessage:"",modes:["blur"]}};export{e as vpaValidationRules};
//# sourceMappingURL=validate.js.map
